let shouldLog = false;

export const logger = {
  disable() {
    shouldLog = false;
  },

  enable() {
    shouldLog = true;
  },

  log(...args) {
    if (shouldLog) {
      args.unshift('Hotkey Service: ');
      // eslint-disable-next-line no-console
      console.log.apply(null, args);
    }
  },
};
